<template>
  <Editor 
    id="editorTemplate"
    :model-value="modelValue" 
    editor-style="height: 320px"
    :modules="modules"
    @update:model-value="onChange"
    @load="onEditorLoad"
  />
</template>

<script>
import Editor from 'primevue/editor';

export default {
  name: "TextEditor",

  components: { Editor },

  props: {
    modelValue: {
      type: String,
      default: null,
    },
  },

  emits: ['update:modelValue', 'onChange'],

  data() {
    return {
      modules: {
        toolbar: [
          // دکمه‌های استایل متن
          ['bold', 'italic', 'underline'],
          
          // دکمه‌های لیست (برای حفظ Bulletها هنگام کپی از ورد)
          [{ 'list': 'ordered'}, { 'list': 'bullet' }], 
          
          // دکمه تغییر جهت متن (RTL / LTR)
          [{ 'direction': 'rtl' }],
          
          // دکمه تراز متن استاندارد
          [{ 'align': ['', 'center', 'left', 'justify'] }],
          
          ['code-block', 'image'],
          
          // دکمه جادویی: پاک کردن فرمت و استایل‌های اضافی (Clear Formatting)
          ['clean'] 
        ]
      }
    };
  },

  methods: {
    onChange(value) {
      this.$emit('update:modelValue', value);
      this.$emit('onChange', value);
    },

    onEditorLoad({ instance }) {
      try {
        const Quill = instance.constructor;
        const AlignClass = Quill.import('formats/align');
        if (AlignClass && AlignClass.whitelist && !AlignClass.whitelist.includes('left')) {
          AlignClass.whitelist.push('left');
          Quill.register(AlignClass, true);
        }
      } catch (error) {  }
      // فیلتر کردن استایل‌های مزاحم هنگام Paste کردن
      instance.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta) => {
        delta.ops.forEach(op => {
          if (op.attributes) {
            // پاک کردن رنگ‌ها، بک‌گراندها، فونت و سایزهای کپی شده
            delete op.attributes.color;
            delete op.attributes.background;
            delete op.attributes.font;
            delete op.attributes.size; 
          }
        });
        return delta;
      });
    }
  }
};
</script>

<style scoped>
/* کل ویرایشگر فونت وزیر بگیرد و راست‌چین شود */
:deep(.ql-container) {
  font-family: Vazir !important;
  direction: rtl;
}

/* در حالت پیش‌فرض، متن به سمت راست تراز شود */
:deep(.ql-editor) {
  direction: rtl;
  text-align: right;
}

/* احترام قطعی به کلاس‌های تراز متن */
:deep(.ql-editor .ql-align-center) { text-align: center !important; }
:deep(.ql-editor .ql-align-right) { text-align: right !important; }
:deep(.ql-editor .ql-align-justify) { text-align: justify !important; }
:deep(.ql-editor .ql-align-left) { 
  text-align: left !important; 
  direction: ltr !important; 
}

/* =======================================================
   جادوی CSS برای تبدیل کلمه undefined به آیکون چپ‌چین
   ======================================================= */

/* 1. نامرئی کردن کلمه undefined (هم در لیست کشویی و هم وقتی انتخاب شده) */
:deep(.ql-picker.ql-align .ql-picker-item[data-value="left"]),
:deep(.ql-picker.ql-align .ql-picker-label[data-value="left"]) {
  color: transparent !important;
}

/* 2. جایگزینی کلمه با آیکون استاندارد چپ‌چین به کمک پس‌زمینه SVG */


:deep(.ql-toolbar.ql-snow) {
  direction: rtl;
}

:deep(.p-editor-toolbar) {
  display: none;
}

:deep(.ql-picker.ql-align .ql-picker-item[data-value="left"]::before),
:deep(.ql-picker.ql-align .ql-picker-label[data-value="left"]::before) {
  content: '\f036' !important; /* کد آیکون چپ‌چین در FontAwesome */
  font-family: "FontAwesome" !important;
  font-size: 14px;
  color: #3699ff;
  display: inline-block;
  vertical-align: middle;
}
</style>